module.exports = __webpack_public_path__ + "img/VTB.8025ead5.svg";